import React from 'react';
import './WelcomeMessage.css';

const WelcomeMessage = ({ isConnected }) => {
  return (
    <div className="welcome-container">
      <h2 className="demo-title">
        <img src="/shield_still.png" alt="Shield" className="demo-shield-icon" />
        Bltz Shield Demo
      </h2>
      <img src="/captain.png" alt="Captain" className="captain-image" />
    </div>
  );
};

export default WelcomeMessage;